/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label.content-day[_ngcontent-%COMP%]{margin-bottom:20px}.starting-time[_ngcontent-%COMP%]{padding-top:10px;color:#1593ff;font-weight:700;cursor:pointer}.starting-time[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{color:#1593ff;font-size:16px}.remove-item[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{position:relative;font-size:18px;color:red;cursor:pointer}"];
export { styles as styles };
